import { Component, OnInit, Inject } from '@angular/core';
import { ModalService } from './modal.service';
import { HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  modal = {
    open: false,
    content: '',
    type: ''
  };

  constructor(
    private modalService: ModalService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.modalService.modalUpdated.subscribe((modalUpdated) => {
      this.modal.open = modalUpdated.open;
      this.modal.content = modalUpdated.content;
      this.modal.type = modalUpdated.type;

      if (modalUpdated.open) {
        this.document.body.classList.add('co-body--fixed');
      } else {
        this.document.body.classList.remove('co-body--fixed');
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      this.closeModal(null);
    }
  }

  preventClosing(event) {
    event.stopPropagation();
  }

  closeModal(event) {
    this.document.body.classList.remove('co-body--fixed');
    this.modal.open = false;
  }
}
